import {
  LOGGED_IN,
  LOGGED_OUT,
  LOGIN_ERROR,
  UNAUTHORIZED
} from "../actions/auth";
// import { isMobileDevice } from "../util/mobile";

const getApiEndpoint = () => {
  if (process.env.NODE_ENV === "development") {
    // if (isMobileDevice()) return "http://192.168.0.135:3000";
    return "http://localhost:3000";
  }
  return "https://safebox-server.now.sh";
};

const initialState = {
  API_ENDPOINT: getApiEndpoint(),
  JWT_COOKIE: "safebox_jwt",
  loginAttempts: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGGED_IN:
      const { token, userID, LoginType } = action.payload;
      return {
        ...initialState,
        loggedIn: true,
        token,
        userID,
        LoginType,
        error: undefined
      };
    case LOGGED_OUT:
      return {
        ...initialState,
        loggedIn: false
      };
    case LOGIN_ERROR:
      return {
        ...initialState,
        error: action.payload
      };
    case UNAUTHORIZED:
      return {
        ...initialState,
        loginAttempts: state.loginAttempts + 1
      };
    default:
      return state;
  }
};
